<template>
  <div style="min-width: 350px;">
    <div
      v-if="productName"
      :class="[!linkActive ? 'product-name text-wrap' : 'btn-link product-name text-wrap pointer','d-flex']"
    >
      <div class="products-name">
        <popper
          trigger="hover"
          :options="popperOption"
          v-if="linkDataAlert && linkUpdated == 2"
        >
          <div
            class="popper p-0"
            style="min-width:300px"
          >
            <h3 class="popover-header">
              <span>
                {{ $t("Last Updated") }}
              </span>
            </h3>
            <div class="popover-body">
              <div class="font-size-sm">
                {{ $t("Request ID") }}: <span v-if="linkDataAlert.request_id">{{ linkDataAlert.request_id }}</span><span v-else>-</span>
              </div>
              <div class="font-size-sm">
                {{ $t("Message") }}: {{ linkDataAlert.message }}
              </div>
              <div
                class="font-size-sm"
              >
                {{ $t("On Hand") }}: {{ linkDataAlert.qty }}
              </div>
              <div
                class="font-size-sm"
              >
                {{ $t("Last Updated") }}: {{ convertTimezone(linkDataAlert.updated) }}
              </div>
            </div>
          </div>
          <a
            slot="reference"
            class="text-warning-400 pointer"
            v-if="linkDataAlert && linkUpdated == 2"
          >
            <i class="fa-solid fa-triangle-exclamation text-warning-400 mr-1" />
          </a>
        </popper>
        <span
          v-if="onClickData && dataTarget && methodsNameOnClick"
          @click="getActionClick()"
          :ref="'row' + onClickData ? onClickData.id : ''"
          data-toggle="modal"
          :data-target="dataTarget ? dataTarget : ''"
          :class="productPublish == 'deleted' ? 'mr-1 strikethrough' : 'mr-1'"
        >
          {{ productName }}
        </span>
        <span
          @click="onActionClicked()"
          v-else
          :class="productPublish == 'deleted' ? 'mr-1 strikethrough' : 'mr-1'"
        >
          {{ productName }}
        </span>
        <span v-if="$storeIndex.isset(() => productBadgeVariant)">
          <span
            v-for="(variant, index) in productBadgeVariant"
            :key="variant.id"
            class="badge mr-1"
            :class="[$storeIndex.badgeClass()[index]]"
            style="min-width: auto;"
          >
            <i class="fa fa-tag" /> {{ variant.slug }}
          </span>
        </span>
      </div>
      <BadgeStatus
        v-if="typeBadge"
        :type-badge-status="typeBadge"
      />
      <div
        v-if="productPublish == 'deleted'"
        class="col-3 pl-0">
        <span
          class="badge bg-orange w-lg-30"
        >
          {{ $t("Product is deleted.") }}
        </span>

      </div>
    </div>
    <div
      v-if="showLineSecond"
      :class="['second-line',showLineSecond ? 'mt-1' : '']"
    >
    
      <i
        v-if="hasStock"
        class="fa-solid fa-warehouse-alt mr-1 text-sku"
      />
      <i
        v-if="productLink"
        v-tooltip:top="$t('Linked')"
        :data-original-title="$t('Linked')"
        class="fas fa-link text-sku"
      />
      <template v-if="productSku && productSku != null && productSku != ''">
        <span :class="productPublish == 'deleted' ? 'font-weight-bold strikethrough' : 'font-weight-bold text-sku'">{{ 'SKU' }}: </span>
        <span
          :class="productPublish == 'deleted' ? 'text-muted cursor-auto strikethrough' : 'text-muted cursor-auto'"
        >{{ productSku }}</span>
      </template>
      <template v-else>
        <span :class="productPublish == 'deleted' ? 'font-weight-bold strikethrough' :'font-weight-bold text-sku'">{{ 'SKU' }}: </span>
        <span
          class="text-muted"
        >
          {{ "-" }}
        </span>
      </template>

      <template v-if="isPrice">
        <span class="font-weight-bold text-sku">{{ 'Price' }}: </span>
        <span
          v-if="productPrice"
          class="text-muted cursor-auto"
        >{{ getNumber(productPrice) | formatNumber }}</span>
        <span
          v-else
          class="text-muted"
        >
          {{ "0.00" }}
        </span>
      </template>

      <template
        v-if="productBarcode"
      >
        <span
          class="font-weight-bold text-sku ml-1"
        >{{ $t("Barcode") }}: </span>
        <span
          v-if="productBarcode"
          class="text-muted cursor-auto"
        >{{ productBarcode }}</span>
        <span
          v-else
          class="text-muted"
        >
          -
        </span>
      </template>
    </div>
  </div>
</template>
<script>
import Popper from 'vue-popperjs';
import { convertTimezone } from "@/common/tenancy/convertTimezone.js";
import numeral from 'numeral'
import BadgeStatus from '@/components/tenancy/center/BadgeStatus.vue';

export default {
  components: {
    Popper,
    BadgeStatus
  },
  props: {
    productName:{
      type: [String],
      default: undefined
    },
    productSku: {
      type: [String],
      default: null
    },
    productLink: {
      type: [String, Number],
      default: null
    },
    productBarcode:{
      type: [String, Number],
      default: null
    },
    productBadgeVariant: {
      type: [Array],
      default: null
    },
    onClickData: {
      type: [Object],
      default: null
    },
    dataTarget: {
      type: [String],
      default: null
    },
    methodsNameOnClick: {
      type: [String],
      default: null
    },
    linkActive: {
      type: Boolean,
      default: true
    },
    showLineSecond: {
      type: Boolean,
      default: true
    },
    linkDataAlert:{
      type: [Object,String],
      default: null
    },
    linkUpdated:{
      type: [Number],
      default: 0
    },
    productPrice:{
      type: [String],
      default: null
    },
    isPrice: {
      type: Boolean,
      default: false
    },
    typeBadge: {
      type: [String],
      default: null
    },
    isStatusMkpReturn: {
      type: Boolean,
      default: false
    },
    productPublish: {
      type: String,
      default: "active"
    },
    hasStock: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      popperOption: {
          placement: 'top',
          modifiers: {
              hide: { enabled: false },
              preventOverflow: { enabled: false },
          }
      },
    }
  },
  mounted() {
  },
  methods: {
    getActionClick(){
      if(this.methodsNameOnClick == 'onActionClicked'){
        this.$parent.$parent.onActionClicked(this.onClickData.action, this.onClickData.data, this.onClickData.id);
        return;
      }
      if(this.methodsNameOnClick == 'openModalViewProductLink'){
        this.$parent.$parent.$parent.openModalViewProductLink(this.onClickData.id, this.onClickData.auto, this.onClickData.data);
        return;
      }
      if(this.methodsNameOnClick == 'onActionClickedProductSet'){
        this.$parent.$parent.$parent.onActionClicked(this.onClickData.action, this.onClickData.data, this.onClickData.id ,'ProductSet');
        return;
      }
    },
    onActionClicked(){
      this.$emit('onActionClicked', this.onClickData);
    },
    convertTimezone(date) {
      return convertTimezone.utcToLocal(date);
    },
    getNumber(price){
      if(typeof price == 'string'){
        return Number(price);
      }
      return price;
    }
  },
  filters: {
    formatNumber: function (value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberNotZero(value) {
      return numeral(value).format("0,0");
    },
  }

}
</script>
<style scoped>
.btn-link.product-name:hover {
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/center/ProductNameComponent.vue